const ITEMS = [
  "Assistenza 100% gratuita",
  "Legge 3/2012 — Sovraindebitamento",
  "Esdebitazione: ricominciare da zero",
  "Supporto psicologico specialistico",
  "Destina il tuo 8 per mille",
  "Sedi a Milano e Gallarate",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-brand-blue text-white overflow-hidden py-4" aria-hidden="true" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-0">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap font-bold text-sm uppercase tracking-[0.2em] px-6">
            {item}
            <span className="ml-12 w-1.5 h-1.5 rounded-full bg-brand-aqua inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
